<template>
  <v-container class="pa-0">
      <v-container 
        class="pa-0 d-flex align-start mx-0"
        :class="{ 'flex-column mx-2 w-100' : isMobile || isTablet, 'w-80': !isMobile && !isTablet }"
      >
        <!--customers-review-->
        <v-chip-group
          v-model="dashboardType"
          mandatory
          active-class="primary"
        >
          <v-chip
            small
            label
            filter
            class="customers-review-box ms-0 mt-0"
            value="homeTabDashboard"
          >
            <v-icon size="15" color="primary" class="me-1">mdi-home</v-icon>
            <span>{{ $t('home') }}</span>
          </v-chip>
          <v-chip
            v-if="$store.getters.getpermission && $store.getters.getpermission.includes('customerReview')"
            small
            filter
            label
            class="customers-review-box mt-0"
            value="customerReview"
          >
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.49995 5C8.49995 5.66304 8.23656 6.29893 7.76772 6.76777C7.29888 7.23661 6.66299 7.5 5.99995 7.5C5.33691 7.5 4.70102 7.23661 4.23218 6.76777C3.76334 6.29893 3.49995 5.66304 3.49995 5C3.49995 4.33696 3.76334 3.70107 4.23218 3.23223C4.70102 2.76339 5.33691 2.5 5.99995 2.5C6.66299 2.5 7.29888 2.76339 7.76772 3.23223C8.23656 3.70107 8.49995 4.33696 8.49995 5ZM10.9 12.506C11.0099 13.048 10.552 13.5 9.99995 13.5H1.99995C1.44695 13.5 0.98995 13.048 1.09795 12.506C1.328 11.3758 1.94159 10.3597 2.83482 9.63C3.72805 8.90027 4.84603 8.50165 5.99945 8.50165C7.15287 8.50165 8.27085 8.90027 9.16408 9.63C10.0573 10.3597 10.6709 11.3758 10.901 12.506M14.002 12.5H12.412C12.4033 12.4027 12.39 12.306 12.372 12.21C12.1805 11.2666 11.7819 10.3776 11.205 9.607C11.94 9.4042 12.7246 9.48889 13.3995 9.84386C14.0743 10.1988 14.5886 10.7974 14.838 11.518C15.018 12.04 14.555 12.5 14.002 12.5ZM12 8.5C12.5304 8.5 13.0391 8.28929 13.4142 7.91421C13.7892 7.53914 14 7.03043 14 6.5C14 5.96957 13.7892 5.46086 13.4142 5.08579C13.0391 4.71071 12.5304 4.5 12 4.5C11.4695 4.5 10.9608 4.71071 10.5857 5.08579C10.2107 5.46086 9.99995 5.96957 9.99995 6.5C9.99995 7.03043 10.2107 7.53914 10.5857 7.91421C10.9608 8.28929 11.4695 8.5 12 8.5Z" fill="#00664D"/>
            </svg>
            <span class="ms-1">{{ $t('customerReview') }}</span>
          </v-chip>
        </v-chip-group>
        <v-divider 
          v-if="dashboardType == 'homeTabDashboard'"
          vertical 
          class="mx-2 mt-1 mb-3"
          style="height: 20px;"
        />
        <div v-if="dashboardType == 'homeTabDashboard'">
          <home />
        </div>
      </v-container>
      <v-row v-if="dashboardType == 'customerReview' && $store.getters.getpermission && $store.getters.getpermission.includes('customerReview')">
        <v-col
          cols="12"
          class="py-0 d-flex justify-end mt-4"
          :class="{'pt-3' : (isMobile ? false : false), 'px-3' : (!isMobile ? true : false), 'ps-0' : (!isMobile ? true : false)}"
        >
          <customerDesk />
        </v-col>
      </v-row>
      <!--dashboard-content-->
      <v-container
        v-if="dashboardType == 'homeTabDashboard' && $store.getters.getpermission && $store.getters.getpermission.includes('overview')"
        class="dashboard-wrapper pa-0 mt-1"
        :class="{ 'pa-2': $vuetify.rtl && isMobile || isTablet }"
      >
        <v-container class="mx-0 pa-0 w-80">
          <sales-cost-overview />
          <v-row 
            class="overview"
            :class="{ 'ml-1' : !$vuetify.rtl && !isMobile && !isTablet , 'ml-0': !$vuetify.rtl && isMobile || isTablet}"
          >
            <v-col class="box pl-0" cols="6" md="3">
              <out-of-stock-overview />
            </v-col>
            <v-col class="box pl-0" cols="6" md="3">
              <new-customer-overview />
            </v-col>
            <v-col class="box pl-0" cols="6" md="3" :class="{ 'pr-0' : !$vuetify.rtl && !isMobile && !isTablet, 'pr-3': !$vuetify.rtl && isMobile || isTablet}">
              <popular-product-overview />
            </v-col>
            <v-col class="box" cols="6" md="3">
              <stagnant-overview />
            </v-col>
          </v-row>
          <v-row 
            class="mt-0 chart-first-row"
            :class="{ 'pl-4' : !$vuetify.rtl && !isMobile && !isTablet, 'pl-0': !$vuetify.rtl && isMobile || isTablet }"
          >
            <v-col cols="12" md="4" class="pl-0 box">
              <debtor-creditor-amount />
            </v-col>
            <v-col cols="12" md="4" class="pl-0 box" :class="{ 'pr-0' : !$vuetify.rtl && !isMobile && !isTablet, 'pr-3': !$vuetify.rtl && isMobile || isTablet}">
              <debtor-customers />
            </v-col>
            <v-col cols="12" md="4" class="box">
              <customer-attraction />
            </v-col>
          </v-row>
          <v-row
            class="chart-fourth-row"
            :class="{ 'pl-4' : !$vuetify.rtl && !isMobile && !isTablet, 'pl-0': !$vuetify.rtl && isMobile || isTablet }"
          >
            <v-col cols="12" md="6" class="pt-0 pl-0 box" :class="{ 'pr-0' : !$vuetify.rtl && !isMobile && !isTablet, 'pr-3': !$vuetify.rtl && isMobile || isTablet }">
              <sales-receipts-compare />
            </v-col>
            <v-col cols="12" md="6" class="pt-0 box">
              <cost-payment-compare />
              <receipt-payment-compare class="mt-3"/>
            </v-col>
          </v-row>
          <v-row 
            class="mt-0 chart-second-row"
            :class="{ 'pl-4' : !$vuetify.rtl && !isMobile && !isTablet, 'pl-0': !$vuetify.rtl && isMobile || isTablet }"
          >
            <v-col cols="12" md="4" class="pl-0 box" :class="{ 'pr-0' : !$vuetify.rtl && !isMobile && !isTablet, 'pr-3': !$vuetify.rtl && isMobile || isTablet }">
              <out-of-stock-product />
            </v-col>
            <v-col cols="12" md="8" class="box">
              <product-sales />
            </v-col>
          </v-row>
          <v-row
            class="mt-0 chart-third-row"
            :class="{ 'pl-4' : !$vuetify.rtl && !isMobile && !isTablet, 'pl-0': !$vuetify.rtl && isMobile || isTablet }"
          >
            <v-col cols="12" md="5" class="pl-0 box" :class="{ 'pr-0' : !$vuetify.rtl }">
              <checks-overview />
            </v-col>
            <v-col cols="12" md="7" class="box">
              <financial-groups-comparison />
            </v-col>
          </v-row>
        </v-container>
        <v-container
          class="pa-0 pt-1"
          :class="[$store.state.isMenuExpanded ? 'w-16' : 'w-18']"
          :style="{ 'left': $vuetify.rtl ? '8px' : '', 'right': !$vuetify.rtl ? '8px' : '' }"
        >
          <info-board />
        </v-container>
      </v-container>
  </v-container>
</template>

<script>
import home from './home'
import SalesCostOverview from './partial/SalesCostOverview.vue'
import FinancialGroupsComparison from './partial/FinancialGroupsComparison.vue'
import OutOfStockProduct from './partial/OutOfStockProduct.vue'
import DebtorCreditorAmount from './partial/DebtorCreditorAmount.vue'
import DebtorCustomers from './partial/DebtorCustomers.vue'
import OutOfStockOverview from './partial/OutOfStockOverview.vue'
import NewCustomerOverview from './partial/NewCustomerOverview.vue'
import PopularProductOverview from './partial/PopularProductOverview.vue'
import StagnantOverview from './partial/StagnantOverview.vue'
import CustomerAttraction from './partial/CustomerAttraction.vue'
import ProductSales from './partial/ProductSales.vue'
import ChecksOverview from './partial/ChecksOverview.vue'
import InfoBoard from './partial/InfoBoard.vue'
import SalesReceiptsCompare from './partial/SalesReceiptsCompare.vue'
import CostPaymentCompare from './partial/CostPaymentCompare.vue'
import ReceiptPaymentCompare from './partial/ReceiptPaymentCompare.vue'

export default {
  name: 'Dashboard',
  components: {
    home,
    customerDesk: () => import('./customerDesk'),
    SalesCostOverview,
    FinancialGroupsComparison,
    OutOfStockProduct,
    DebtorCreditorAmount,
    DebtorCustomers,
    OutOfStockOverview,
    NewCustomerOverview,
    PopularProductOverview,
    StagnantOverview,
    CustomerAttraction,
    ProductSales,
    ChecksOverview,
    InfoBoard,
    SalesReceiptsCompare,
    CostPaymentCompare,
    ReceiptPaymentCompare
  },
  data () {
    return {
      dashboardType: 'home',
      items: [],
      checkType: 'payCheck'
    }
  },
  watch: {
    '$store.state.permissions': {
      deep: true,
      handler (newVal) {
      }
    }
  },
  activated () {
    if (this.$store.state.teacherAccess) {
      this.$router.push({ name: 'academyDashboard' })
    }
  },
  beforeMount () {
    if (this.$store.state.teacherAccess) {
      this.$router.push({ name: 'academyDashboard' })
    }
  },
}
</script>
<style scoped>
.dashboard-wrapper {
  display: flex;
  align-items: center;
}
.w-80 {
  width: 80%;
}
.w-16 {
  width: 16%;
}
.w-18 {
  width: 18%;
}
.dashboard-wrapper .container:nth-child(2) {
  position: fixed;
  top: 57px;
  transition: width .1s;
}
.customers-review-box {
  background-color: #fff !important;
  color: #000 !important;
  border-radius: 5px !important;
  display: flex;
  align-items: center;
  width: fit-content;
  white-space: nowrap;
  height: 26px;
}
.v-chip:before {
  background-color: transparent !important;
}
::v-deep .v-chip-group .v-slide-group__content {
  padding: 0 !important;
}
@media (max-width: 1220px) {
  .dashboard-wrapper {
    flex-direction: column;
  }
  .dashboard-wrapper .container:nth-child(1) {
    padding: 8px;
    width: 100%;
    padding-bottom: 0 !important;
  }
  .dashboard-wrapper .container:nth-child(2) {
    position: static;
    width: 100%;
  }
  .dashboard-wrapper .overview .box:nth-child(2),
  .dashboard-wrapper .chart-fourth-row .box:nth-child(1) {
    padding-left: 12px !important;
  }
  .dashboard-wrapper .overview .box:nth-child(1),
  .dashboard-wrapper .overview .box:nth-child(2) {
    padding-bottom: 0;
  }
  .dashboard-wrapper .chart-first-row .box:nth-child(1),
  .dashboard-wrapper .chart-first-row .box:nth-child(2),
  .dashboard-wrapper .chart-second-row .box:nth-child(1),
  .dashboard-wrapper .chart-third-row .box:nth-child(1) {
    padding-left: 12px !important;
    padding-bottom: 0 !important;
  }
}
</style>
